import { HttpClient } from "@angular/common/http";
import { constantvalues } from "../../const";
import { Injectable } from "@angular/core";
import { environment } from '../environments/environment.development'

@Injectable({
    providedIn: 'root'
})

export class ResetPasswordService{
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }

    getUserDetailsByUserId(userId: string){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_ACCOUNT_ADMIN}/${userId}`);
    }

    resetPassword(userDetails: any){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.RESET_PASSWORD_FOR_ACCOUNT_ADMIN}`, userDetails);
    }

    uploadProfile(userProfile: FormData, userId: number) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.USER_DETAILS}/${userId}/upload-profile`, userProfile);
    }
}